import { NgModule } from '@angular/core';
import { PrizmInputAllowedSymbolsDirective } from './input-allowed-symbols.directive';

@NgModule({
  declarations: [PrizmInputAllowedSymbolsDirective],
  exports: [PrizmInputAllowedSymbolsDirective],
})
export class PrizmInputAllowedSymbolsModule {}
